export default "__VITE_ASSET__CWPbZ6DB__"